import React, {Component} from 'react';
import BaseLayout from './../../templates/base';
import Loading from '../../elements/loading';
import AgreementsEditForm from './../../elements/revision/agreements';

class RevisionAgreements extends Component {
	render() {
		let {agreements, revision} = this.props;
		return (agreements.isFetching) ? <Loading/> : <AgreementsEditForm
			agreements={agreements}
			revision={revision}
			type={this.props.match.params.type}
			modality={this.props.match.params.modality}
			state={this.props.match.params.state}
			municipality={this.props.match.params.municipality}
			municipalities={this.props.municipalities}
			changeStatus={this._changeStatus}
			fetchMunicipalities={this.fetchMunicipalities}
			saveAgreements={this.saveAgreement}
		/>;
	}

	constructor(props) {
		super(props);
		this._changeStatus = this._changeStatus.bind(this);
		this.saveAgreement = this.saveAgreement.bind(this);
		this.fetchMunicipalities = this.fetchMunicipalities.bind(this);
	}

	componentWillMount() {
		let {state, municipality, modality, type} = this.props.match.params;
		//this.props.notificationTypesFetch();
		return this.props.fetchProjectAgreementsWithRevision(modality, state, municipality, type === 'administrativo' ? 'admin' : 'legal');
	}

	componentWillReceiveProps(nextprops) {
		if (nextprops.match.params !== this.props.match.params) {
			let {modality, state, municipality, type} = nextprops.match.params;
			//this.props.notificationTypesFetch();
			return this.props.fetchProjectAgreementsWithRevision(modality, state, municipality, type === 'administrativo' ? 'admin' : 'legal');
		}
	}

	_changeStatus(model, values, field) {
		this.props.change(model, values);
		this.props.change(field.model, field.field);
	}

	saveAgreement(type, modality, state, municipality, values) {
		this.props.saveAgreements(type, modality, state, municipality, values);
	}

	fetchMunicipalities(agency) {
		this.props.fetchMunicipalities(agency);
	}

}

export default BaseLayout(RevisionAgreements, {
	title: 'Revisión de Convenios',
	subnav: {
		icon: 'fa-check-square-o',
		name: 'Revisión'
	},
	stateNav: true
});


// WEBPACK FOOTER //
// ./src/layouts/revision/agreements.jsx